import React, { useEffect, useState } from "react";
import { GoDot } from "react-icons/go";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import PageLayout from "../../../Components/Layout/PageLayout";
import { FormTemplate } from "../../../Components/Forms/InputTemplate";
import { FormProvider, useForm } from "react-hook-form";
import { FiX } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { FormatDateTime } from "../../../../../utils/functions/ResourceFunctions";
import {
  ApproveProcRequsition,
  DeclineProcRequsition,
  // DeleteProcRequsition,
  GetSingleProcRequisitions,
  NotifyProcRequsition,
} from "../../../../../utils/redux/Procurement/ProcurementSlice";
import { PageActions } from "../../../Components/Misc/Actions";
import Table from "../../../Components/Table/Table";
import { useApprovals } from "../../Vendors/VendorApprovals/useApprovals";
import { DEFINED_PERMISSIONS } from "../../../../../utils/const";
import { GetConsummableSingleRegister } from "../../../../../utils/redux/ConsummableSetUp/ConsummableSetUpSlice";
import { GetAssetSingleRegister } from "../../../../../utils/redux/AssetsSetUp/AssetSetUpSlice";
import { USER_CATEGORY } from "../../../../../utils/Enums";
import { GetLocalStorage } from "../../../../../utils/functions/GetLocalStorage";
import {
  STATUS,
  findState,
} from "../../Vendors/Management/ViewVendorsOperations";
import { toast } from "react-toastify";
import CustomModal from "../../Finance/PayrollAutoRun/components/CustomModal";
import { Autocomplete, TextField } from "@mui/material";
import axios from "axios";
import {
  useGetBudgetDetailsByIdQuery,
  useGetBudgetDetailsQuery,
  useGetBudgetSummaryQuery,
  useLinkBudgetToPaymentMutation,
} from "../../../../api";
import { FormatCurrency } from "../../../../../utils/functions/FormatCurrency";
import PreviewBtn from "../../../Components/Modals/PreviewBtn";
import { formatNumberWithCommas } from "../../../../../utils/Misc";

function ViewEmployeeProcRequisition() {
  const token = JSON.parse(localStorage.getItem("user"))?.userToken;
  const [loading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const hrRoot = process.env.REACT_APP_BACKEND_HR_URL;
  const [pageSize] = useState(1000000);
  const { category } = GetLocalStorage();
  // const { consummableSetUp, assetSetUp } = useSelector((state) => state);
  const [openBudgetModal, setOpenBudgetModal] = useState(false);
  const [newBudgetData, setNewBudgetData] = useState([]);
  const [isYear, setIsYear] = useState(new Date().getFullYear());
  const [departmentValue, setDepartmentValue] = useState();
  const [budgetValue, setBudgetValue] = useState();
  // const [isId, setIsId] = useState(null);
  const [pageNumber] = useState(1);

  const [budgetId, setBudgetId] = useState();
  const [newBudgetId, setNewBudgetId] = useState();

  const { data: budgetDetails } = useGetBudgetDetailsQuery({
    pageSize,
    pageNumber,
    SummaryId: budgetId,
  });
  console.log("budget details", budgetDetails);
  const { data: budgetSummaryData } = useGetBudgetSummaryQuery({
    Year: isYear,
    Department: departmentValue,
    pageSize,
    PageNumber: pageNumber,
  });

  // const payload = {
  //   id: data?.proc_req_data?.responseObject?.budgetId,
  // };
  // const { data: budgetSummaryDataById } = useGetBudgetDetailsByIdQuery(payload);

  const closeBudgetModal = () => {
    setOpenBudgetModal(false);
  };
  const formMethods = useForm({
    mode: "all",
  });
  const { handleSubmit } = formMethods;

  const submit = (e) => {
    alert("clicked");
  };

  const dispatch = useDispatch();

  const data = useSelector((state) => state?.procurement);
  // console.log(data?.proc_req_data?.responseObject?.budgetId  );
  const vendor = data?.proc_req_data?.responseObject;
  console.log("data selector", vendor);

  const payload = {
    id: data?.proc_req_data?.responseObject?.budgetId,
  };
  const { data: budgetSummaryDataById } = useGetBudgetDetailsByIdQuery(payload);

  console.log("budget summary", budgetSummaryDataById);

  const params = useParams();
  const { uuId: id } = params;
  console.log(params);

  function createYearArray() {
    const currentYear = new Date().getFullYear();
    const lowestYear = 2002;
    const years = [];

    for (let year = currentYear; year >= lowestYear; year--) {
      years.push(year);
    }

    return years;
  }
  const yearArray = createYearArray();

  useEffect(() => {
    const getDepartment = async () => {
      try {
        const res = await axios.get(
          `${hrRoot}/Department/AllDepartment?&PageSize=${pageSize}&PageNumber=1`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (res) {
          setNewBudgetData(res?.data?.responseObject?.pageItems);
        }
      } catch (err) {
        console.log(err);
      }
    };
    getDepartment();
  }, [hrRoot, pageSize, token]);

  useEffect(() => {
    // dispatch(GetSingleVendor(id));
    dispatch(GetSingleProcRequisitions(id));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (vendor?.procurementTypeId === 1) {
      vendor?.assetId &&
        dispatch(GetConsummableSingleRegister(vendor?.assetId));
    } else {
      vendor?.assetId && dispatch(GetAssetSingleRegister(vendor?.assetId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vendor?.assetId]);

  const { openModal, closeModal } = useApprovals({});
  const { stat } = findState(vendor?.registrationStatus);
  const budgetData = budgetSummaryData?.result ?? [];
  // const handleBudgetModal = () => {
  //   setOpenBudgetModal(true);
  //   // setPopover(null);
  // };

  const [onLinkBudget] = useLinkBudgetToPaymentMutation();
  const handleLinkBudget = async () => {
    console.log(budgetId);
    try {
      setIsLoading(true);
      const res = await onLinkBudget({
        BatchId: vendor?.uniqueIdentifier,
        BudgetId: newBudgetId,
      }).unwrap();
      if (res.successful === true) {
        setIsLoading(false);
        setOpenBudgetModal(false);
        toast.success(res?.statusMessage);
      }
    } catch (err) {
      setIsLoading(false);
      // setOpenBudgetModal(false);
      // handleClose();
      // setOpenModal(false);
      toast.error(err?.data?.statusMessage);
    }
  };

  // Function to convert base64 string to downloadable file
  const base64ToFile = (base64String, fileName, fileType) => {
    const byteCharacters = window.atob(base64String);
    const byteNumbers = new Array(byteCharacters.length)
      .fill()
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const file = new Blob([byteArray], { type: fileType });
    const fileURL = URL.createObjectURL(file);
    return (
      <a
        href={fileURL}
        download={fileName}
        target="_blank"
        rel="noopener noreferrer"
        className="text-green-500"
      >
        {fileName}
      </a>
    );
  };

  // console.log('GetLocalStorage()',GetLocalStorage());
  // console.log('return if all are true', [STATUS.APPROVED, USER_CATEGORY.VENDOR === GetLocalStorage?.()?.category].every(Boolean));

  return (
    <PageLayout title={"Requisition Details"} hasBack={true}>
      <div className={DashboardStyle.app_view_controls}></div>
      <FormProvider {...formMethods}>
        <FormTemplate
          className={DashboardStyle.view_app_components}
          handleSubmit={handleSubmit(submit)}
        >
          <section
            style={{
              backgroundColor: "#F8FBF8",
              border: "1px solid #D9E9DA",
              borderRadius: "8px",
            }}
            className={DashboardStyle.form_section}
          >
            <h4 className={DashboardStyle.form_section_title}>
              Process <br /> Information
            </h4>
            <div className={DashboardStyle.labels_group}>
              <div>
                <div>
                  <div
                    style={{
                      display: "flex",
                      marginBottom: "0.8rem",
                      gap: "0.6rem",
                      alignItems: "center",
                    }}
                  >
                    <p style={{ marginBottom: "0px" }}>Initiated By:</p>
                    <h4>{vendor?.initiatorName}</h4>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      marginBottom: "0.8rem",
                      gap: "0.6rem",
                      alignItems: "center",
                    }}
                  >
                    <p style={{ marginBottom: "0px" }}>Date:</p>
                    <h4>{FormatDateTime(vendor?.dateCreated, "ll")}</h4>
                  </div>
                </div>
                <div>
                  {/* <div
                    style={{
                      display: "flex",
                      marginBottom: "0.8rem",
                      gap: "0.6rem",
                      alignItems: "center",
                    }}
                  >
                    <p style={{ marginBottom: "0px" }}>Created By:</p>
                    <h4>{vendor?.initiatorName}</h4>
                  </div> */}
                </div>
                <div>
                  <div
                    style={{
                      display: "flex",
                      marginBottom: "0.8rem",
                      gap: "0.6rem",
                      alignItems: "center",
                    }}
                  >
                    <p style={{ marginBottom: "0px" }}>Last Reviewed:</p>
                    <h4>{vendor?.lastReveiwed?.lastReviewedBy}</h4>
                  </div>
                  {/* <div
                    style={{
                      display: "flex",
                      marginBottom: "0.8rem",
                      gap: "0.6rem",
                      alignItems: "center",
                    }}
                  >
                    <p style={{ marginBottom: "0px" }}>Date:</p>
                    <h4>
                      {FormatDateTime(vendor?.lastReveiwed?.lastReveiwedByDate)}
                    </h4>
                  </div> */}
                </div>
              </div>
              <div>
                {/* <div>
                  <p>Levels of Approval:</p>
                  <h4>{vendor?.levelsOfApproval}</h4>
                </div> */}

                <div>
                  <p>Request Id:</p>
                  <h4>{vendor?.uniqueIdentifier}</h4>
                </div>

                <div>
                  <p>Process Status</p>
                  <h4
                    style={{
                      color:
                        vendor?.registrationStatus === "Initiated"
                          ? "#815103"
                          : vendor?.registrationStatus === "Approved"
                          ? "#0F6308"
                          : vendor?.registrationStatus === "Declined" ||
                            "Canceled"
                          ? "#8A002B"
                          : "",
                    }}
                  >
                    {vendor?.registrationStatus}
                  </h4>
                </div>
                <div>
                  {/* <button className={DashboardStyle.view_more_action_button}>
                    <span>Preview Stage</span>{" "}
                    <FiExternalLink
                      className={DashboardStyle.view_more_action_button_icon}
                    />
                  </button> */}
                  <PreviewBtn
                    allData={vendor?.approvalResponse}
                    data={vendor?.approvalResponse?.history}
                  />
                </div>
              </div>
            </div>
          </section>
          <section
            style={{
              borderTop: "unset",
            }}
            className={DashboardStyle.form_section}
          >
            <h4 className={DashboardStyle.form_section_title}>
              Requisition <br /> Information
            </h4>
            <div className={DashboardStyle.labels_group}>
              <div>
                <div>
                  <p>Item Name</p>
                  <h4>{vendor?.assetName}</h4>
                </div>
                <div>
                  <p>Procurement Type</p>
                  <h4>{vendor?.procurementType}</h4>
                </div>
                <div>
                  <p>Description</p>
                  <h4>{vendor?.description}</h4>
                </div>
              </div>
              <div>
                <div>
                  <p>Unit Price</p>
                  <h4>{vendor?.unitPrice}</h4>
                </div>
                <div>
                  <p>Quantity</p>
                  <h4>{vendor?.quantity}</h4>
                </div>

                <div>
                  <p>Total Price</p>
                  <h4>{vendor?.totalPrice}</h4>
                </div>
              </div>

              <div>
                {vendor?.procurementType === "Asset" && (
                  <div>
                    {/* <p>Brand</p>
                    <h4>{vendor?.assetBrand}</h4> */}
                  </div>
                )}
                <div>
                  <p>Deadline</p>
                  <h4>{FormatDateTime(vendor?.deadline)}</h4>
                </div>
              </div>
            </div>
          </section>
          <section
            style={{
              borderTop: "unset",
            }}
            className={DashboardStyle.form_section}
          >
            <h4 className={DashboardStyle.form_section_title}>
              Budget <br /> Information
            </h4>
            <div className={DashboardStyle.labels_group}>
              <div>
                <div>
                  <p>Item Name</p>
                  <h4>
                    {budgetSummaryDataById?.responseObject?.item || "N/A"}
                  </h4>{" "}
                  {/* Updated with item name */}
                </div>
                <div>
                  <p>Budget Type</p>
                  <h4>
                    {budgetSummaryDataById?.responseObject?.budgetType || "N/A"}
                  </h4>{" "}
                  {/* Updated with budget type */}
                </div>
                <div>
                  <p>Description</p>
                  <h4>
                    {budgetSummaryDataById?.responseObject?.description ||
                      "N/A"}
                  </h4>{" "}
                  {/* Updated with description */}
                </div>
              </div>
              <div>
                <div>
                  <p>Unit Price</p>
                  <h4>
                    {FormatCurrency(
                      budgetSummaryDataById?.responseObject?.unitPrice
                    ) || "N/A"}
                  </h4>{" "}
                  {/* Updated with unit price */}
                </div>
                <div>
                  <p>Quantity</p>
                  <h4>
                    {budgetSummaryDataById?.responseObject?.quantity || "N/A"}
                  </h4>{" "}
                  {/* Updated with quantity */}
                </div>

                <div>
                  <p>Total Price</p>
                  <h4>
                    {FormatCurrency(
                      budgetSummaryDataById?.responseObject?.total
                    ) || "N/A"}
                  </h4>{" "}
                  {/* Updated with total price */}
                </div>
              </div>

              <div>
                <div>
                  <p>Actual Expenditure</p>
                  <h4>
                    {FormatCurrency(
                      budgetSummaryDataById?.responseObject?.actualExpenditure
                    ) || "N/A"}
                  </h4>{" "}
                  {/* Updated with actual expenditure */}
                </div>
                <div>
                  <p>Date Created</p>
                  <h4>
                    {FormatDateTime(
                      budgetSummaryDataById?.responseObject?.createdDate,
                      "ll"
                    ) || "N/A"}
                  </h4>{" "}
                  {/* Updated with date created */}
                </div>
                <div>
                  <p>Last Updated</p>
                  <h4>
                    {FormatDateTime(
                      budgetSummaryDataById?.responseObject?.updateDate,
                      "ll"
                    ) || "N/A"}
                  </h4>{" "}
                  {/* Updated with last updated date */}
                </div>
              </div>

              {vendor?.beneficiaryEl?.map((dat, key) => (
                <>
                  <div>
                    <div>
                      <p>Beneficiary Name {key + 1}</p>
                      <h4> {dat?.beneficiaryName}</h4>{" "}
                    </div>

                    <div>
                      <p>Beneficiary Type {key + 1}</p>
                      <h4>
                        {" "}
                        {(dat?.beneficiaryType === 0 && "Individual") ||
                          (dat?.beneficiaryType === 1 && "Department") ||
                          (dat?.beneficiaryType === 2 && "Branch") ||
                          (dat?.beneficiaryType === 3 && "Director") ||
                          (dat?.beneficiaryType === 4 && "Unit") ||
                          (dat?.beneficiaryType === 1 && "Global")}
                      </h4>{" "}
                    </div>

                    <div>
                      <p>Branch {key + 1}</p>
                      <h4> {dat?.branch}</h4>{" "}
                    </div>
                  </div>

                  <div>
                    <div>
                      <p>Department {key + 1}</p>
                      <h4> {dat?.department}</h4>{" "}
                    </div>

                    <div>
                      <p>Quantity {key + 1}</p>
                      <h4> {dat?.quantity}</h4>{" "}
                    </div>

                    <div>
                      <p>Unit {key + 1}</p>
                      <h4> {dat?.unit}</h4>{" "}
                    </div>
                  </div>
                </>
              ))}
            </div>
          </section>

          {category !== USER_CATEGORY.VENDOR && (
            <>
              <>
                {" "}
                {vendor?.procurementType === "Asset" && (
                  <section className={DashboardStyle.form_section}>
                    <h4 className={DashboardStyle.form_section_title}>
                      Beneficiary <br /> Information
                    </h4>
                    <div className={DashboardStyle.labels_group}>
                      {vendor?.beneficiaryEl?.map((x) => (
                        <div>
                          <div>
                            <p>Beneficiary Name</p>
                            <h4>{x?.beneficiaryName}</h4>
                          </div>

                          <div>
                            <p>Department</p>
                            <h4>
                              {x?.department}
                              {/* {x?.department ||
                          `${!x?.branch ? "-" : x?.beneficiaryName}`} */}
                            </h4>
                          </div>
                          <div>
                            <p>Branch</p>
                            <h4>{x?.branch}</h4>
                          </div>
                          <div>
                            <p>Quantity</p>
                            <h4>{x?.quantity}</h4>
                          </div>
                        </div>
                      ))}
                    </div>
                  </section>
                )}
              </>
              <section className={DashboardStyle.form_section}>
                <h4 className={DashboardStyle.form_section_title}>
                  Vendor <br /> Information
                </h4>
                <div className={DashboardStyle.labels_group}>
                  <div style={{ display: "flex", flexWrap: "wrap" }}>
                    {vendor?.vendors?.map((x) => (
                      <div
                        style={{
                          width: "210px",
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "0.5rem",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          navigate(`/dashboard/vendors/${x?.id}/view-vendor`)
                        }
                      >
                        <GoDot style={{ color: "red" }} />
                        <h4>{x?.name}</h4>
                      </div>
                    ))}
                  </div>
                </div>
              </section>
            </>
          )}

          <section
            style={{
              borderTop: "unset",
            }}
            className={DashboardStyle.form_section}
          >
            <h4 className={DashboardStyle.form_section_title}>
              Quotation <br /> Details
            </h4>
            <div className="flex flex-col gap-y-6">
              {vendor?.quotation?.map((q, idx) => (
                <div className="flex flex-col gap-y-4">
                  <h4 className="font-semibold text-sm">{`Quotation Item ${
                    idx + 1
                  }`}</h4>
                  <div className={DashboardStyle.labels_group}>
                    <div>
                      <div>
                        <p>Unit Price</p>
                        <h4>
                          {q?.unitPrice
                            ? `${q.currency}${formatNumberWithCommas(
                                q?.unitPrice
                              )}`
                            : "N/A"}
                        </h4>
                        {/* Updated with unit price */}
                      </div>
                      <div>
                        <p>Delivery Cost</p>
                        <h4>
                          {q?.deliveryCost
                            ? `${q.currency}${formatNumberWithCommas(
                                q?.deliveryCost
                              )}`
                            : "N/A"}
                        </h4>
                        {/* Updated with quantity */}
                      </div>

                      <div>
                        <p>Total Price</p>
                        <h4>
                          {q?.totalPrice
                            ? `${q.currency}${formatNumberWithCommas(
                                q?.totalPrice
                              )}`
                            : "N/A"}
                        </h4>
                        {/* Updated with total price */}
                      </div>
                    </div>

                    <div>
                      <div>
                        <p>Delivery Schedule</p>
                        <h4>{FormatDateTime(q?.deliverySchedule)}</h4>
                      </div>

                      <div>
                        <p>Support Included</p>
                        <h4>{q?.supportIncluded ? "Yes" : "No"}</h4>
                      </div>

                      <div>
                        <p>Warranty</p>
                        <h4>{q?.waranty}</h4>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className={DashboardStyle.form_section}>
            <h4 className={DashboardStyle.form_section_title}>
              Documents <br /> Uploads
            </h4>
            <div
              className={` ${DashboardStyle.labels_group} ${DashboardStyle.labels_group_downloads} `}
            >
              <Table>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Document Name</th>
                    <th>Document Size</th>
                    <th>Document Type</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {vendor?.requisitionDocuments?.map((x, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{x?.fileName}</td>
                      <td>{x?.size}</td>
                      <td>{x?.fileExtension}</td>
                      {/* <td>{FormatDateTime(x?.dateUploaded)}</td> */}
                      {/* <td>
                        <TableActionsDownload url={x?.fileUrl} />
                      </td> */}
                      <td>
                        {base64ToFile(
                          x?.file,
                          x?.fileName + x?.fileExtension,
                          "application/pdf"
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </section>
        </FormTemplate>
      </FormProvider>

      {openBudgetModal && (
        <CustomModal hideModal={setOpenBudgetModal}>
          <div
            className="bg-white w-full overflow-hidden"
            style={{
              borderTopLeftRadius: "5px",
              borderTopRightRadius: "5px",
            }}
          >
            <header className="w-full py-3 bg-customGreen px-4 flex items-center justify-between">
              <p className="text-white text-baseFont font-[700]">
                Update Budget
              </p>
              <button
                onClick={closeBudgetModal}
                className="text-baseFont text-white"
                // onClick={closeModal}
              >
                <FiX />
              </button>
            </header>
            {/*main*/}
            <div className="grid grid-cols-2 gap-5 p-8">
              <div className="w-full mb-5">
                <h1 className="text-baseFont text-customGreen mb-2">
                  Department
                </h1>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={newBudgetData?.map((d, _index) => ({
                    label: d?.name,
                    value: d?.name,
                    id: d?.id,
                    key: _index,
                  }))}
                  getOptionLabel={(option) => option?.label}
                  onChange={(e, newValue) => {
                    // console.log(newValue);
                    setDepartmentValue(newValue?.value || "");
                    // setIsId(newValue?.id || "");
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      value={departmentValue}
                      placeholder="Choose Department"
                    />
                  )}
                />
              </div>
              <div className="w-full mb-5">
                <h1 className="text-baseFont text-customGreen mb-2">Year</h1>
                <select
                  className="text-baseFont w-full py-3 rounded border border-slate-300 bg-white  h-[50px] px-2 outline-none focus:ring-0"
                  onChange={(e) => setIsYear(e.target.value)}
                  // value={payrollType}
                >
                  {yearArray.map((year, index) => (
                    <option key={index} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>
              <div className="w-full mb-5">
                <h1 className="text-baseFont text-customGreen mb-2">Budget</h1>
                <Autocomplete
                  disablePortal
                  disabled={budgetData?.length < 1}
                  id="combo-box-demo"
                  options={budgetData.map((d, _index) => ({
                    label: `Budget for ${d?.department} for year ${d?.year}`,
                    value: d?.name,
                    id: d?.id,
                    key: _index,
                  }))}
                  getOptionLabel={(option) => option?.label}
                  onChange={(e, newValue) => {
                    setBudgetValue(newValue?.value || "");
                    setBudgetId(newValue?.id || "");
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      value={budgetValue}
                      placeholder={
                        budgetData?.length < 1
                          ? `No budget for ${departmentValue}`
                          : "Choose budget"
                      }
                    />
                  )}
                />
              </div>
              <div className="w-full mb-5">
                <h1 className="text-baseFont text-customGreen mb-2">
                  Budget Item
                </h1>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  disabled={!budgetDetails?.result}
                  options={budgetDetails?.result?.map((d, _index) => ({
                    label: d?.item,
                    value: d.item,
                    key: _index,
                    id: d.id,
                  }))}
                  onChange={(e, newValue) => {
                    console.log(newValue);
                    setNewBudgetId(newValue?.id || "");
                  }}
                  renderInput={(params) => (
                    <TextField {...params} placeholder="Choose budget item" />
                  )}
                />
              </div>
            </div>
            <div className="w-full flex items-center justify-end gap-5 pt-3 px-7">
              <button
                className=" px-[24px] py-[12px] rounded-[8px] text-baseFont text-customGreen"
                style={{ border: "1px solid #305f32" }}
                onClick={closeBudgetModal}
              >
                Cancel
              </button>
              <button
                onClick={handleLinkBudget}
                disabled={loading}
                className="bg-[#29382A] text-white px-[24px] py-[12px] rounded-[8px]"
              >
                {loading ? "Updating..." : "Update to Budget"}
              </button>
            </div>
          </div>
        </CustomModal>
      )}
    </PageLayout>
  );
}

export default ViewEmployeeProcRequisition;
